/** 全站主题（light/sepia/dark）：读写 k-soup 本地存储并广播变更事件 */
import { local } from 'k-soup/utils/store';
import { readbookStoreMap } from '@/storage/readbookStoreMap';

/** 全站统一外观主题（首页 / 书架 / 阅读器外壳） */
export type AppThemeMode = 'light' | 'sepia' | 'dark';

export type HomeThemeMode = 'light' | 'dark';

export const APP_THEME_STORAGE_KEY = readbookStoreMap.APP_THEME.name;
export const APP_THEME_EVENT = 'app-theme-change';

const DEFAULT_THEME: AppThemeMode = 'dark';

function parseTheme(value: unknown): AppThemeMode | null {
  if (value === 'light' || value === 'sepia' || value === 'dark') return value;
  return null;
}

function readLegacyReadbookTheme(): AppThemeMode | null {
  const stored = local.get<{ theme?: unknown }>(readbookStoreMap.SETTINGS.name);
  return parseTheme(stored?.theme);
}

/** 读取当前全站主题（含旧版阅读器设置迁移） */
export function getAppTheme(): AppThemeMode {
  const cached = parseTheme(local.get<AppThemeMode>(APP_THEME_STORAGE_KEY));
  if (cached) return cached;

  const legacy = readLegacyReadbookTheme();
  if (legacy) {
    local.set(APP_THEME_STORAGE_KEY, legacy);
    return legacy;
  }

  return DEFAULT_THEME;
}

/** 写入全站主题并广播变更（同步阅读器本地配置中的 theme 字段） */
export function setAppTheme(theme: AppThemeMode): void {
  local.set(APP_THEME_STORAGE_KEY, theme);

  const stored =
    local.get<Record<string, unknown>>(readbookStoreMap.SETTINGS.name) ?? {
      fontSize: 16,
      lineHeight: 1.6,
    };
  local.set(readbookStoreMap.SETTINGS.name, { ...stored, theme });

  window.dispatchEvent(new CustomEvent(APP_THEME_EVENT, { detail: theme }));
}

/** 首页二元主题 ↔ 全站主题 */
export function appThemeToHome(theme: AppThemeMode): HomeThemeMode {
  return theme === 'dark' ? 'dark' : 'light';
}

export function homeThemeToApp(theme: HomeThemeMode): AppThemeMode {
  return theme;
}

export function isAppDark(theme: AppThemeMode): boolean {
  return theme === 'dark';
}
